import PenerimaanPettyCashApi from './PenerimaanPettyCashApi';

export default PenerimaanPettyCashApi;
